import type { FaireProductEntity } from "../../entity_types/product";

export const p_r8vqq6ev4t: FaireProductEntity = {
  token: "p_r8vqq6ev4t",
  type: "product",
  name: "Odds Silicone Fidget Magnets",
  brandToken: "b_vw97v1k7ax",
  brandName: "Speks",
  imageUrl:
    "https://cdn.faire.com/fastly/a9999b1164cc54718ab8c181b401bf6c2a29719e8ae42588c413674b0e5d2293.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/54ec0a02969da2e114c65a8a5a822877d43339a3c0fe127bef9c048b137eeea5.jpeg",
    "https://cdn.faire.com/fastly/94e89dbaea39de59c61039d0e3ed25ac24af0ff2e1bf87f238222623538f63d8.jpeg",
    "https://cdn.faire.com/fastly/71514d72a5052220e4f0ca6a44cea4d220ba0b6f7a58e64c15a898d860d84412.jpeg",
    "https://cdn.faire.com/fastly/a39d11d3a4f0fe19ca0e8a07328d6dcb5d1011b145de0b3f500d6b84d88cea5b.jpeg",
    "https://cdn.faire.com/fastly/b5e3e93d76e243cfcf845c97d719ac9a97150bad49072bfeb47960d4114c7c15.jpeg",
  ],
  priceDollars: 300,
  description:
    'Meet Odds, the soft silicone fidget magnets that come in 4 unique textures. Designed for palm massaging satisfaction, Odds are a quiet fidget that won\'t disrupt study hall or your deskmates. Mix is 24 Units (6 of each color) and comes packaged in PDQ box for easy, fast sales.\n\n• Unit MSRP: $24.95\n• Display size: 9.9" x 12.3" x 13.5"\n• Packaging size: 2" x 2" x 5"',
  tags: [],
  msrpDollars: 600,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:39.518Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
